import React, { useEffect, useState } from 'react'
import Switch from 'react-switch';
import CustomColumn from '../../../../customControl/CustomColumn'
import { ConfirmationModal } from '../../../../customControl/ConfirmationModal';
import CommonFilter from '../../../../customControl/CommonFilter';
import CustomTable from '../../../../customControl/CustomTable';
import { alphaSpace, formatDate, getDateCombination, isImageValidPng } from '../../../commonClass/CommonValidation';
import { getAllData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import { CommonFileURLWithFolder, ImageUpload } from '../../../../ImageUpload/ImageCommon';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../_actions/loader.actions';

const CollectionName = ({ useradd, useredit, userexport }) => {
    const dispatch = useDispatch();
    const [actionType, setActionType] = useState('Add');
    const [modalShow, setModalShow] = useState(false);
    const [isChange, setIsChange] = useState(true)

    const [searchvalue, setSearchValue] = useState('');
    const [searchby, setSerachBy] = useState('All');

    const [CollectionNameList, setCollectionNameList] = useState([]);
    const [filterList, setFilterList] = useState([]);
    const [formError, setFormError] = useState({});
    const [formValue, setFormValue] = useState({
        CollectionId: 0,
        CollectionName: "",
        ImageName: "",
        ImagePath: "",
        IsActive: false,
        NeedToUpdateImg: false,
        UserId: 0
    });

    const handleisActive = (value) => {
        if (actionType === 'Add') {
            handleOnChange('IsActive', value)
        } else {
            setModalShow(true)
        }
    };

    const handleConfirmation = (action) => {
        if (action === true) {
            handleOnChange('IsActive', !formValue.IsActive)
        }
        setModalShow(false);
    }

    const columns = [
        {
            name: 'Sr. No',
            key: 'srNo',
            sortable: true,
            reorder: true,
            selector: (data) => data?.srNo,
        },
        {
            name: 'Collection Name',
            key: 'CollectionName',
            sortable: true,
            reorder: true,
            selector: (data) => data?.CollectionName,
        },
        {
            name: 'Active',
            key: 'ActiveTitle',
            sortable: true,
            reorder: true,
            selector: (data) => data?.ActiveTitle,
        },
        {
            name: 'Created Date',
            key: 'CreatedDateFormat',
            sortable: true,
            reorder: true,
            selector: (air) => new Date(air.CreatedDate),
            format: (data) => data.CreatedDateFormat,
        },
        {
            name: 'Edit',
            selector: (data) => <button
                type='button'
                className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}>
                <i className="fa fa-edit" onClick={() => handleEditViewMode("Update", data?.CollectionId)}></i>
            </button>
        },
        {
            name: 'View',
            selector: (data) => <i className="fa fa-eye cursor_pointer" onClick={() => handleEditViewMode("View", data?.CollectionId)}></i>
        }
    ]

    const handleUploadImageLoad = (e) => {
        let error = {}
        if (isImageValidPng(e.target.files[0].name)) {
            const files = e.target.files;
            const filename = getDateCombination(files[0].name);

            setFormValue({
                ...formValue,
                ImageName: filename,
                ImagePath: 'CMS/activity/' + filename,
                ImageFile: files[0],
                NeedToUpdateImg: true
            })
            setIsChange(false);
            setFormError({})

        }
        else {
            document.getElementById("collection_img").value = "";
            error.ImageName = "Only PNG file type is accepted.";
            setFormError(error);
            return;
        }
    }

    const getCollectionList = async () => {
        dispatch(loaderActions.start())
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const collectionList = await getAllData('/master/v1/getallactivitycollectionlist');
            if (collectionList?.status) {
                const collectiondata = collectionList?.data?.map((colletion, index) => (
                    {
                        ...colletion,
                        srNo: index + 1,
                        ActiveTitle: colletion?.IsActive ? "Active" : "Inactive",
                        CreatedDateFormat: formatDate(colletion?.CreatedDate)
                    }))
                setCollectionNameList(collectiondata)
                setFilterList(collectiondata)
                dispatch(loaderActions.end())
            }
            else {
                dispatch(loaderActions.end());
            }
        } else {
            ClearLocalStorage();
            dispatch(loaderActions.end());
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }

    const handleEditViewMode = async (type, id) => {
        dispatch(loaderActions.start())
        setFormError({})
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const collection = await getAllData(`/master/v1/getactivitycollectionbyid?CollectionId=${id}`);
            if (collection.status) {
                setActionType(type);
                setIsChange(true)
                setFormValue({
                    ...formValue,
                    CollectionId: collection?.data?.[0]?.CollectionId,
                    CollectionName: collection?.data?.[0]?.CollectionName,
                    ImageName: collection?.data?.[0]?.ImageName,
                    ImagePath: collection?.data?.[0]?.ImagePath,
                    IsActive: collection?.data?.[0]?.IsActive
                })
            }
            else {
                dispatch({ type: 'ALERTING', message: collection.message })
            }
            dispatch(loaderActions.end());
        } else {
            ClearLocalStorage();
            dispatch(loaderActions.end());
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }

    }

    const handleOnChange = (name, value) => {
        setFormError({});
        setIsChange(false)
        setFormValue({ ...formValue, [name]: value })
    }

    const isValidData = () => {
        let errorMessage = {}
        let isError = false;

        if (formValue.CollectionName?.trim().length <= 0) {
            errorMessage = { ...errorMessage, 'CollectionName': 'Kindly Enter Collection Name.' }
            isError = true
        } else if (formValue.CollectionName?.trim().length > 100) {
            errorMessage = { ...errorMessage, 'CollectionName': 'Maximum 100 characters allowed.' }
            isError = true
        }
        else if (filterList.some((collection) => (collection.CollectionName.trim() === formValue.CollectionName.trim() && collection.CollectionId !== formValue.CollectionId))) {
            errorMessage = { ...errorMessage, 'CollectionName': 'Collection name is already exists' }
            isError = true
        }

        if (!formValue?.ImageFile && formValue.ImageName.length <= 0) {
            errorMessage = { ...errorMessage, ImageName: 'Please upload the Image.' }
            isError = true
        }

        if (formValue.NeedToUpdateImg) {
            let fileSize = formValue?.ImageFile?.size / 1024;
            fileSize = fileSize / 1024
            if (fileSize > 5) {
                errorMessage = { ...errorMessage, ImageName: 'The file size exceeds the 5 MB limit. Please upload a smaller image.' }
                isError = true
            }
        }
        setFormError({ ...formError, ...errorMessage })
        return isError
    }

    const AddCategoryName = async () => {
        if (!isValidData()) {
            let IsImageUpdate = false;

            dispatch(loaderActions.start())
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                if (formValue.NeedToUpdateImg) {
                    IsImageUpdate = await ImageUpload('CMS/activity/', formValue.ImageName, formValue.ImageFile);
                    setFormValue({ ...formValue, NeedToUpdateImg: false })
                } else {
                    IsImageUpdate = true
                }

                if (IsImageUpdate) {
                    let user = GetLocalStorage()
                    const collection = await postUsersData('/master/v1/insertorupdateactivitycollection', { ...formValue, UserId: user?.userMasterID });

                    if (collection?.status) {
                        clearData();
                        getCollectionList();
                        dispatch(loaderActions.end())
                        dispatch({ type: 'ALERTING', message: collection.message })
                    }
                    else {
                        dispatch(loaderActions.end())
                        dispatch({ type: 'ALERTING', message: collection.message })
                        return;
                    }
                }
            }
            else {
                ClearLocalStorage();
                dispatch(loaderActions.end());
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
    }

    useEffect(() => {
        getCollectionList()
    }, [])

    const clearData = () => {
        setFormValue({
            CollectionId: 0,
            CollectionName: "",
            ImageName: "",
            ImagePath: "",
            IsActive: false,
            UserId: 0
        });
        setActionType('Add');
        setFormError({});
        document.getElementById("collection_img").value = "";
    }
    return (
        <div className="container-fluid form_border py-5 my-3">
            <div className="row">
                <CustomColumn labelText='Collection Name' labelId='CollectionName' isRequired >
                    <input
                        type="text"
                        className='form-control'
                        name="CollectionName"
                        id="CollectionName"
                        disabled={actionType === 'View'}
                        value={formValue.CollectionName}
                        placeholder='Collection Name'
                        maxLength={100}
                        onChange={(e) => handleOnChange(e.target.name, alphaSpace(e.target.value))}
                    />
                    {formError.CollectionName && <p className='text-danger text-start'>{formError.CollectionName}</p>}
                </CustomColumn>

                <CustomColumn colNum={6} labelText='Upload Image' labelId='UploadImage' isRequired>
                    <div>
                        <div className="input-group">
                            <input
                                type="file"
                                className='form-control btn_add'
                                id="collection_img"
                                accept=".png"
                                disabled={actionType === 'View'}
                                onChange={handleUploadImageLoad}
                            />
                            <label
                                htmlFor="UploadImage"
                                className='input-group-text'
                            >
                                Browse
                            </label>
                        </div>
                        {formValue.ImageName && <p className='text-start'>{formValue.ImageName}</p>}
                        {formError.ImageName && <p className='text-danger text-start'>{formError.ImageName}</p>}
                    </div>
                </CustomColumn>

                <CustomColumn colNum={6} labelText='Active' labelId='Active'>

                    <Switch
                        onChange={handleisActive}
                        checked={formValue.IsActive}
                        className="react-switch"
                        disabled={actionType === 'View' ? true : false}
                    />

                    <ConfirmationModal
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                        noconfirm={() => handleConfirmation(false)}
                        yesconfirm={() => handleConfirmation(true)}
                    />
                </CustomColumn>
            </div>

            {formValue.ImagePath.length > 0 && (
                <div className='row my-3'>
                    <div className="col-lg-2 col-md-3 col-6 mx-auto mt-2" >
                        <img
                            src={formValue.NeedToUpdateImg ? URL.createObjectURL(formValue?.ImageFile) : `${CommonFileURLWithFolder}${formValue.ImagePath}`}
                            className="img-fluid w-100"
                            alt="uploaded"
                            style={{ objectPosition: "right top" }}
                        />
                    </div>
                </div>
            )}


            <div className="d-flex justify-content-center mb-4">
                <button
                    type="button"
                    className="btn btn-primary mx-1"
                    disabled={(actionType === "Add" && !useradd) || isChange || actionType === 'View' ? true : false || isChange}
                    onClick={() => { AddCategoryName() }}
                >
                    {actionType === 'Add' ? 'Add' : 'Update'}
                </button>

                <button
                    type="button"
                    className="btn btn-primary mx-1"
                    onClick={() => { clearData() }}
                >
                    Clear
                </button>
            </div>

            <CommonFilter
                columns={columns}
                filterList={filterList}
                searchDisabled={false}
                getdata={getCollectionList}
                setlistdata={setCollectionNameList}
                searchvalue={searchvalue}
                setSearchValue={setSearchValue}
                searchby={searchby}
                setSerachBy={setSerachBy}
            />
            
            <CustomTable
                className="last_two_column_freeze freezEditViewAtLast"
                columns={columns}
                data={CollectionNameList}
            />
        </div>
    )
}

export default CollectionName